import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Typography, Card, CardContent, Grid, Box, CardHeader } from '@mui/material'
import { ArcElement } from 'chart.js'
import { Chart as ChartJS } from 'chart.js'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/system'
import { useIsMobile } from '@/hooks/useSizeBreakpoints'

ChartJS.register(ArcElement)
type OnboardingProgressCardProps = {
  steps: StepProps[]
}
export const OnboardingProgressCard = ({ steps }: OnboardingProgressCardProps) => {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <Card sx={{
      boxShadow: 3,
    }}>
      <CardHeader title={
        <div style={{ textAlign: 'center' }}>
          <Typography variant="h6" color="white">
            {t('page.onboarding.stepProgress.title.label')}
          </Typography>
        </div>
      } style={{ backgroundColor: theme.palette.primary.main, alignItems: "center" }} />
      <CardContent>
        <Grid container spacing={2} direction="column">
          {steps.map((step, index) => (
            <Grid item xs={4} key={index}>
              <StepProgress {...step} />
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  )
}

export type StepProps = {
  title: string
  icon: React.ReactNode
  totalNumberOfChildSteps?: number
  numberOfCompletedChildSteps?: number
}

export const StepProgress = (props: StepProps) => {
  const { title, totalNumberOfChildSteps = 0, numberOfCompletedChildSteps = 0 } = props
  const { t } = useTranslation()
  const isTooSmall = useIsMobile()

  const remainingSteps = totalNumberOfChildSteps - numberOfCompletedChildSteps

  const data = {
    labels: ['Completed', 'Remaining'],
    datasets: [
      {
        data: [numberOfCompletedChildSteps, remainingSteps],
        backgroundColor: ['green', 'lightgrey'],
        hoverBackgroundColor: ['green', 'lightgrey'],
      },
    ],
  }

  return (
    <Grid container direction="row" alignItems="center" spacing={2}>
      {!isTooSmall && <Grid item>
        <Doughnut
          data={data}
          width={50}
          height={50}
          options={{
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                enabled: false,
              },
            },
          }}
        />
      </Grid>}
      <Grid item>
        <Box display="flex" flexDirection="column" alignItems="flex-start">
          <Typography variant="body1">{`${numberOfCompletedChildSteps} / ${totalNumberOfChildSteps}`}</Typography>
          <Typography variant="caption">{t(`page.onboarding.steps.${title}.title`)}</Typography>
        </Box>
      </Grid>
    </Grid>
  )
}
